module.exports = __webpack_public_path__ + "static/img/question6-2.3582a3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question6-2.png
// module id = 24Ya
// module chunks = 1